import React, { Component } from 'react';
import Helmet from 'react-helmet';
import Header from '../components/Header/Header';
import Transition from '../components/Transition/Transition';
import config from '../../data/SiteConfig';
import './contact.scss';

class ContactPage extends Component {
  render() {
    return (
      <div>
        <div className="page-container">
          <Helmet title={`Contact | ${config.siteTitle}`} />
          <Transition>
            <Header data={this.props.data} />
            <div className="contact-banner">
              <img src="/banner.jpg" alt="banner" />
            </div>
            <main className="contact-content">
              <div className="contact-row">
                <div className="contact-col">
                  <h1>FIND US</h1>
                  <address className="contact-address">
                    19/F, Building 2, Publishing Tower,<br />
                    Laoshan Distinct, Qingdao,<br />
                    Shandong Province, PRC
                  </address>
                  <address className="contact-address">山东省青岛市崂山区出版大厦2号楼19F</address>
                </div>
                <div className="contact-col">
                  <h1>SAY HELLO</h1>
                  <dl className="contact-methods">
                    <dt>Tel</dt>
                    <dd>
                      <a href="tel:+8653288985711">+86 532 8898 5711</a>
                    </dd>
                    <dt>Email</dt>
                    <dd>
                      <a href="mailto:info@flatwhitemotion.com">info@flatwhitemotion.com</a>
                    </dd>
                  </dl>
                </div>
              </div>
              <div className="contact-info" dangerouslySetInnerHTML={{ __html: this.props.data.markdownRemark.html }} />
            </main>
          </Transition>
        </div>
      </div>
    );
  }
}

export default ContactPage;

/* eslint no-undef: "off" */
export const pageQuery = graphql`
  query ContactPageQuery {
    markdownRemark(fields: { slug: { eq: "/contact" } }) {
      html
    }
    allTags: allMarkdownRemark {
      edges {
        node {
          frontmatter {
            tags
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/contact.jsx